// extracted by mini-css-extract-plugin
module.exports = {"root":"PasswordResetForm_root__18J72","password":"PasswordResetForm_password__3EtbL"};